import React from 'react';
import ReactDOM from 'react-dom';
import {Modal, Button, Col, Row, InputGroup, Thumbnail, Carousel, Grid, Image} from 'react-bootstrap';
import Dict from 'dict-lib';
import BUtils from "./../utilities/BaseUtilities";
import stylesScNavbar from './../dict-components/navbar/ScNavbar.module.css';


export class ImageGallery extends React.Component {

    constructor(props) {
        super(props);

        this.state = ({
            show: true,
            images: [],
            imageToShow: null,
            imageReady: false,
            carouselReady: false
        });

        this.storedUrl = BUtils.getServerUrl();

        this._close = this._close.bind(this);

    }

    componentDidMount() {
        Dict.call('/service/retrieveDictionaryImageGallery').then((images => {
            this.setState({images});

            this._filterByUniqueImage(images, filtered => {
                console.log('✅ Elementi unici:', filtered);
            });

            setTimeout(() => {
                this.setState({carouselReady: true});
            }, 300); //
        }))
    }

    componentDidUpdate(prevProps, prevState) {
        const justLoadedImage =
            this.state.imageToShow &&
            this.state.imageReady &&
            (!prevState.imageToShow || !prevState.imageReady);

        if (justLoadedImage) {
            setTimeout(() => {
                this._dragElement(
                    'row-image-gallery-modal-selected-img',
                    'row-image-gallery-modal-selected-img__header'
                );
            }, 0);
        }
    }

    /*_aggregatedList(data) {
        const entryMap = {}; // entryId → Set of items
        const itemMap = new Map(); // item → Set of entryIds

        data.forEach(item => {
            const ids = new Set();

            const rootId = item['rootEntryId'];
            if (rootId) ids.add(rootId);

            const translationIds = item['subentries.senses.translation_group.translations.entry_id'];
            if (Array.isArray(translationIds)) {
                translationIds.forEach(id => ids.add(id));
            }

            itemMap.set(item, ids);

            ids.forEach(id => {
                if (!entryMap[id]) entryMap[id] = new Set();
                entryMap[id].add(item);
            });
        });

        const visited = new Set();
        const result = [];

        for (const item of itemMap.keys()) {
            if (visited.has(item)) continue;

            const group = new Set();
            const queue = [item];

            while (queue.length) {
                const current = queue.pop();
                if (visited.has(current)) continue;
                visited.add(current);
                group.add(current);

                const ids = itemMap.get(current);
                ids.forEach(id => {
                    entryMap[id].forEach(relatedItem => {
                        if (!visited.has(relatedItem)) {
                            queue.push(relatedItem);
                        }
                    });
                });
            }

            result.push(Array.from(group));
        }

        return result;
    }*/

    _filterByUniqueImage(data, callback) {
        const seen = [];
        const result = [];

        const loadImage = async url => {
            const prefix = url.startsWith('http') ? '' : this.storedUrl + '/';
            const res = await fetch(prefix + url);
            const blob = await res.blob();
            return new Promise(resolve => {
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = () => resolve(img);
                img.src = URL.createObjectURL(blob);
            });
        };

        const getImageData = (img, width = 64, height = 64) => {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            return ctx.getImageData(0, 0, width, height).data;
        };

        const comparePixels = (data1, data2) =>
            data1.length === data2.length && data1.every((v, i) => v === data2[i]);

        const process = async input => {
            for (const item of input) {
                const url = item['title.images.multimedia_crop_image'];
                if (!url)
                    continue;

                const img = await loadImage(url);
                const data = getImageData(img);

                const isDuplicate = seen.some(prev => comparePixels(prev, data));
                if (!isDuplicate) {
                    seen.push(data);
                    result.push(item);
                }
            }

            callback(result);
        };

        process(data); // ✅ passaggio esplicito
    }


    _close() {
        this.setState({show: false}, function () {
            setTimeout(function () {
                ReactDOM.unmountComponentAtNode(document.getElementById("dict-modal-container"));
            }, 500);
        }.bind(this));
    }

    _dragElement(elementId, headerId) {
        const elmnt = document.getElementById(elementId);

        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(headerId)) {
            // if present, the header is where you move the DIV from:
            document.getElementById(headerId).onmousedown = dragMouseDown;
        } else {
            // otherwise, move the DIV from anywhere inside the DIV:
            elmnt.onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        let currentX = 0;
        let currentY = 0;

        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();

            const dx = e.clientX - pos3;
            const dy = e.clientY - pos4;

            pos3 = e.clientX;
            pos4 = e.clientY;

            currentX += dx;
            currentY += dy;

            elmnt.style.transform = `translate(${currentX}px, ${currentY}px)`;
        }

        function closeDragElement() {
            // stop moving when mouse button is released:
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    render() {
        const images = this.state.images;

        const GRID_ROWS = 4;
        const GRID_COLS = 6;
        const IMAGES_PER_SLIDE = GRID_ROWS * GRID_COLS;


        const imagesPerSlide = IMAGES_PER_SLIDE;
        const slides = [];

        for (let i = 0; i < images.length; i += imagesPerSlide) {
            const slideImages = images.slice(i, i + imagesPerSlide);
            slides.push(slideImages);
        }

        var prefix = '';
        var desc = '';
        if (this.state.imageToShow !== null) {
            prefix = this.state.imageToShow['title.images.multimedia_image'].startsWith('http') ? '' : this.storedUrl + '/';
            desc = this.state.imageToShow &&
                this.state.imageToShow['subentries.senses.translation_group.translations.description'];
        }

// esempio: "https://myapp.example.com" oppure "http://localhost:3000"


        return <Modal
            id="dict-create-lexeme"
            dialogClassName={stylesScNavbar['image-gallery-modal-navbar']}
            show={this.state.show}
            onHide={this._close}
            restoreFocus
        >
            <Modal.Header closeButton>
                <Modal.Title><strong>Galleria Immagini</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {this.state.carouselReady &&
                    <Carousel interval={null} className={stylesScNavbar['image-gallery-modal-list__item__carousel']}>
                        {slides.map((slideImages, slideIndex) => (
                            <Carousel.Item key={slideIndex}>
                                <Grid>
                                    {[...Array(GRID_ROWS)].map((_, rowIndex) => (
                                        <Row key={rowIndex}>
                                            {slideImages
                                                .slice(rowIndex * GRID_COLS, rowIndex * GRID_COLS + GRID_COLS)
                                                .map((item, colIndex) => {
                                                    const prefix = item['title.images.multimedia_crop_image'].startsWith('http') ? '' : this.storedUrl + '/';
                                                    return <Col key={colIndex} xs={Math.floor(12 / GRID_COLS)}>
                                                        <Image
                                                            src={prefix + item['title.images.multimedia_crop_image']}
                                                            alt={`img-${rowIndex}-${colIndex}`}
                                                            thumbnail
                                                            className={BUtils.joinClasses(stylesScNavbar['image-gallery-modal-list__item__img'], stylesScNavbar['image-gallery-modal-list__item__img__selected__' + (item === this.state.imageToShow)])}
                                                            onClick={() => {
                                                                this.setState({imageToShow: item, imageReady: false});
                                                            }}
                                                        />
                                                    </Col>
                                                })}
                                        </Row>
                                    ))}
                                </Grid>
                            </Carousel.Item>
                        ))}
                    </Carousel>}
                {this.state.imageToShow !== null ?
                    <Row id="row-image-gallery-modal-selected-img"
                         className={BUtils.joinClasses(stylesScNavbar['row-image-gallery-modal-selected-img'], stylesScNavbar['row-image-gallery-modal-selected-img-ready__' + this.state.imageReady])}>
                        <div
                            className={stylesScNavbar['row-image-gallery-modal-selected-img-bar']}
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                padding: '4px 4px',
                            }}
                        >
                            <Button
                                bsSize="small"
                                style={{
                                    fontSize: '22px',
                                    lineHeight: '1',
                                    padding: '0',
                                    paddingLeft: '4px',
                                    paddingRight: '4px',
                                    marginLeft: '8px',
                                    color: 'white',
                                    backgroundColor: 'black',
                                    border: 0
                                }}
                                onClick={() => this.setState({imageToShow: null, imageReady: false})}
                            >
                                ×
                            </Button>
                        </div>
                        <Thumbnail href="#" a
                                   lt="171x180"
                                   className={stylesScNavbar['image-gallery-modal-selected-img']}
                        >
                            <img
                                src={prefix + this.state.imageToShow['title.images.multimedia_image']}
                                alt="selected"
                                onLoad={() => {
                                    setTimeout(() => this.setState({imageReady: true}), 300);
                                }}
                                className={stylesScNavbar['image-gallery-modal-selected-img-max-dim']}
                            />
                        </Thumbnail>
                        <Row className={stylesScNavbar['image-gallery-modal-selected-img-caption-container']}>
                            <a
                                href={window.location.origin + '/lexeme/' + this.state.imageToShow.rootEntryId}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={stylesScNavbar['row-image-gallery-modal-selected-img_entry']}
                                dangerouslySetInnerHTML={{__html: this.state.imageToShow.entryForm}}
                            />
                        </Row>
                        <Row className={stylesScNavbar['image-gallery-modal-selected-img-caption-container-tr']}>
                            {desc ? desc.slice(0, 2).map((item, index) => {
                                return <a
                                    href={window.location.origin + '/lexeme/' + this.state.imageToShow['subentries.senses.translation_group.translations.entry_id'][index]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={stylesScNavbar['div-image-gallery-modal-selected-img_tr']}
                                    dangerouslySetInnerHTML={{__html: item}}
                                />
                            }) : ''}
                        </Row>
                    </Row> : ''}
            </Modal.Body>
        </Modal>

    }
}
